import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'

import * as routeActions from 'actions/routeActions'

const styles = theme => ({
  root: {
    height: 40,
    fontSize: 15,
    minWidth: 175,
    padding: '0 15px',
    textTransform: 'none',
  },
  primary: {
    color: theme.palette.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  secondary: {
    border: `1px solid ${theme.palette.background.dark}`,
  },
})

class LinkButton extends React.Component {
  handleRedirect = (to) => {
    this.props.actions.redirect(to)
  };

  render() {
    const {
      classes,
      className,
      variant,
      label,
      to,
      ...buttonProps
    } = this.props
    return (
      <Button
        onClick={() => this.handleRedirect(to)}
        classes={{
          root: classNames(classes.root, className, classes[variant]),
        }}
        {...buttonProps}>
        {label}
      </Button>
    )
  }
}

LinkButton.defaultProps = {
  variant: 'primary',
}

LinkButton.propTypes = {
  actions: PropTypes.object,
  classes: PropTypes.object,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
  return {
    state,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, routeActions)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const LinkButtonComponent = withStyles(styles)(LinkButton)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkButtonComponent)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/LinkButton.js